import { createSelector } from '@reduxjs/toolkit';

import configSelector from './config';

const sortItemsSelector = createSelector(configSelector, config =>
  config.sort.items.map(item => ({
    ...item,
    key: Array.isArray(item.key) ? item.key : [item.key],
  })),
);

export default sortItemsSelector;
